<template>
    <div class="ebm-setting-skeleton">
        <!-- Header row -->
        <div class="grid grid-cols-4 gap-4 mb-4">
            <div class="bg-gray-200 dark:bg-slate-900 rounded-md animate-pulse h-20" v-for="i in 4" :key="'header-' + i"></div>
        </div>

        <!-- Data rows -->
        <div class="space-y-3">
            <div class="grid grid-cols-4 gap-4" v-for="row in 5" :key="'row-' + row">
                <div class="bg-gray-200 dark:bg-slate-900 rounded-md animate-pulse h-20" v-for="col in 4" :key="'cell-' + row + '-' + col"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EbmSettingSkeleton'
}
</script>

<style scoped>
@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: .5;
    }
}

.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>